<template>
  <div style="width: 100%">
    <v-row v-if="diagnostico">
      <v-col>
        <v-tooltip
          bottom
          max-width="500"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <select-simple-unidade
                :value="unidade"
                :mapeamento-id="diagnostico.mapeamento.id"
                @input="changeUnidade"
              />
            </div>
          </template>
          <span>Selecione para escolher uma unidade.</span>
        </v-tooltip>
      </v-col>
      <v-col>
        <v-tooltip
          bottom
          max-width="500"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-select
                v-model="desempenho"
                :items="desempenhos"
                item-text="usuario.nome"
                label="Servidores avaliados:"
                prepend-icon="supervisor_account"
                return-object
              />
            </div>
          </template>
          <span>Selecione para carregar os dados referentes a outro servidor.</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row class="justify-center ma-2">
      <v-col v-if="loaded && desempenho && teveAvaliacao">
        <keep-alive>
          <resultado-agrupado
            key="SERVIDORES"
            :desempenho="desempenho"
            tipo="SERVIDORES"
            menu-acesso="MONITORAMENTO"
          />
        </keep-alive>
      </v-col>
      <v-col v-if="desempenho && !teveAvaliacao">
        <app-alert
          :message="motivoNaoTeveAvaliacao"
          type="info"
        />
      </v-col>
    </v-row>

    <app-loading :visibilidade="loading" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppLoading from '@/components/core/AppLoading';
import AppAlert from '@/components/core/AppAlert';
import SelectSimpleUnidade from '@/components/SelectSimpleUnidade';
import ResultadoAgrupado from '@/components/desempenho/ResultadoAgrupadoResponsabilidade';

export default {
  name: 'ResultadoServidoresResponsabilidade',

  components: {
    AppLoading,
    AppAlert,
    SelectSimpleUnidade,
    ResultadoAgrupado,
  },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      unidade: {
        selecionado: null,
      },
      desempenho: null,
      resultadoAgrupado: ResultadoAgrupado,
    };
  },

  computed: {
    ...mapState({
      desempenhosServidores: (state) => state.monitoramentoDesempenho.desempenhos,
      loaded: (state) => state.monitoramentoDesempenho.loaded,
    }),
    ...mapGetters({
      getUnidadesByAcesso: 'unidade/getUnidadesByAcesso',
    }),
    acesso() {
      return this.$store.state.auth.comissao ? 'COMISSAO' : 'COMUM';
    },
    unidades() {
      return this.getUnidadesByAcesso(this.acesso, this.diagnostico.mapeamento.id);
    },
    teveAvaliacao() {
      return (
        !this.desempenho.foiDispensado
        && this.desempenho.teveAutoavaliacaoResponsabilidade
        && this.desempenho.teveAvaliacaoGestorResponsabilidade
      );
    },
    motivoNaoTeveAvaliacao() {
      let motivo = '';
      if (this.desempenho.foiDispensado) {
        return this.desempenho.motivoNaoTeveAutoavaliacaoResponsabilidade;
      }
      if (!this.desempenho.teveAutoavaliacaoResponsabilidade || !this.desempenho.teveAvaliacaoGestorResponsabilidade) {
        if (!this.desempenho.teveAutoavaliacaoResponsabilidade) {
          motivo += `${this.desempenho.motivoNaoTeveAutoavaliacaoResponsabilidade} `;
        }
        if (!this.desempenho.teveAvaliacaoGestorResponsabilidade) {
          motivo += `${this.desempenho.motivoNaoTeveAvaliacaoGestorResponsabilidade}`;
        }
      }
      return motivo;
    },
    desempenhos() {
      return this.$store.state.monitoramentoDesempenho.desempenhos.filter(
        (d) => this.unidade.selecionado && d.unidade.id === this.unidade.selecionado.idVersao,
      );
    },
  },

  watch: {
    desempenhos(value) {
      if (value.length > 0) {
        this.desempenho = { ...value[0] };
      }
    },
    diagnostico() {
      this.unidade.selecionado = { ...this.unidades[0] };
    },
  },

  created() {
    if (this.acesso === 'COMISSAO') {
      this.unidade.selecionado = { ...this.unidades[0] };
    } else {
      const unidade = this.unidades.find((u) => u.id === this.$store.state.auth.unidade.id);
      if (unidade) {
        this.unidade.selecionado = { ...unidade };
      }
    }
  },

  methods: {
    changeUnidade() {
      if (this.desempenhos.length > 0) {
        this.desempenho = { ...this.desempenhos[0] };
      }
    },
  },
};
</script>
